
import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage'; 

const Layout = () => import('XH/views/Layout.vue');
const Login = () => import('XH/views/Login/Login.vue');
const Timeout = () => import('XH/views/ErrorHandle/Timeout.vue');
const Offline = () => import('XH/views/ErrorHandle/Offline.vue');
const Home = () => import('XH/views/Home/Home.vue');
const ErrorMsg = () => import('XH/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('XH/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('XH/views/Register/Register.LinkFailure.vue');
const TradeAgreement = () => import('XH/views/Login/TradeAgreement.vue');  
const Register = () => import('XH/views/Register/Register.vue');   
const Player = () => import('XH/views/Player/Player.vue');
const CreatePlayer = () => import('XH/views/Player/Player.Create.vue');
const RegisterLink = () => import('XH/views/RegisterLink/RegisterLink.vue');
const DailyPayManagement = () => import('XH/views/DailyPay/DailyPayManagement.vue');
const DailyPayManagementCG = () => import('XH/views/DailyPayCG/DailyPayManagement.vue');
const DailyRebateManagement = () => import('XH/views/DailyRebate/DailyRebateManagement.vue');
const TrendChartStatistics = () => import('XH/views/TrendChart/Statistics.vue');
const DownloadCenter = () => import('XH/views/DownloadCenter/DownloadCenter.vue');
const DepositQrcode = () => import('XH/views/Deposit/DepositQrcode.vue');
const Bet = () => import('XH/views/Bet/Bet.vue');
const BetPro = () => import('XH/views/Bet/BetPro.vue');
const ComboBet = () => import('XH/views/ComboBet/ComboBet.vue');
const ComboBetPro = () => import('XH/views/ComboBet/ComboBetPro.vue');
const MultiBet = () => import('XH/views/MultiBet/MultiBet.vue');
const MultiBetPro = () => import('XH/views/MultiBet/MultiBetPro.vue');
const Predict = () => import('XH/views/Predict/Predict.vue');
const AccountInfo = () => import('XH/views/AccountCenter/AccountInfo.vue');
const AccountSecurity = () => import('XH/views/AccountCenter/AccountSecurity.vue');
const BankCard = () => import('XH/views/BankCard/BankCard.vue');
const Deposit = () => import('XH/views/Deposit/Deposit.vue');
const DrawHistory = () => import('XH/views/DrawHistory/DrawHistory.vue');
const WinningNumbers = () => import('XH/views/WinningNumbers/WinningNumbers.vue');
const Announcement = () => import('XH/views/Announcement/Announcement.vue');
const WithdrawRequest = () => import('XH/views/WithdrawRequest/WithdrawRequest.vue');
const DepositAndWithdrawRecord = () => import('XH/views/DepositAndWithdrawRecord/DepositAndWithdrawRecord.vue');
const BetRecord = () => import('XH/views/BetRecord/BetRecord.vue');
const ScheduleRecord = () => import('XH/views/ScheduleRecord/ScheduleRecord.vue');
const AwardDetail = () => import('XH/views/AwardDetail/AwardDetail.vue');
const ExternalGameTransRecord = () => import('XH/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const CashFlowRecord = () => import('XH/views/CashFlowRecord/CashFlowRecord.vue');
const ExternalGameTrans = () => import('XH/views/ExternalGameTrans/ExternalGameTrans.vue');
const CustomerService = () => import('XH/views/Chat/Chat.CustomerService.vue');
const ProfitReport = () => import('XH/views/ProfitReport/ProfitReport.vue');
const TeamProfitReport = () => import('XH/views/ProfitReport/ProfitReport.Team.vue');
const TeamExternalGameProfitReport = () => import('XH/views/ProfitReport/ProfitReport.ExternalGame.Team.vue');
const ExternalGame = () => import('XH/views/ExternalGame/ExternalGame.vue');
const Activity = () => import('XH/views/Activity/Activity.vue');
const GraphicTeaching = () => import('XH/views/Help/GraphicTeaching.vue');
const IFrame = () => import('XH/views/IFrame.vue');

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/TradeAgreement', component: TradeAgreement, meta: { ignoreAuth: true } },
        { path: '/Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', component: LinkFailure, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        //以下是登入後須套用header、footer、chat的頁面
        {
            path: '/', component: Layout,
            children: [
                { path: '/', name: 'Home', component: Home },

                { path: '/Bet/:id', name: 'Bet', redirect: _betRedirect },
                { path: '/BetClassic/:id', name: 'BetClassic', component: Bet, meta: { betRedirectName: 'Bet', betClientTemplate: 'Classic' } },
                { path: '/BetPro/:id', name: 'BetPro', component: BetPro, meta: { betRedirectName: 'Bet', betClientTemplate: 'Pro' } },
                { path: '/ComboBet', name: 'ComboBet', redirect: _betRedirect },
                { path: '/ComboBetClassic', name: 'ComboBetClassic', component: ComboBet, meta: { betRedirectName: 'ComboBet', betClientTemplate: 'Classic' } },
                { path: '/ComboBetPro', name: 'ComboBetPro', component: ComboBetPro, meta: { betRedirectName: 'ComboBet', betClientTemplate: 'Pro' } },
                { path: '/MultiBet/:type', name: 'MultiBet', redirect: _betRedirect },
                { path: '/MultiBetClassic/:type', name: 'MultiBetClassic', component: MultiBet, meta: { betRedirectName: 'MultiBet', betClientTemplate: 'Classic' } },
                { path: '/MultiBetPro/:type', name: 'MultiBetPro', component: MultiBetPro, meta: { betRedirectName: 'MultiBet', betClientTemplate: 'Pro' } },
                { path: '/Predict/:id', name: 'Predict', component: Predict },
                { path: '/ExternalGameTrans/', name: 'ExternalGameTrans', component: ExternalGameTrans },
                { path: '/Player', component: Player, meta: { isAgentAllow: true } },
                { path: '/CreatePlayer', component: CreatePlayer, meta: { isAgentAllow: true } },
                { path: '/RegisterLink', component: RegisterLink, meta: { isAgentAllow: true } },
                { path: '/DailyPayManagement', component: DailyPayManagement, meta: { isAgentAllow: true } },
                { path: '/DailyPayManagementCG', component: DailyPayManagementCG, meta: { isAgentAllow: true } },
                { path: '/DailyRebateManagement', component: DailyRebateManagement, meta: { isAgentAllow: true } },
                { path: '/TrendChartStatistics', component: TrendChartStatistics, meta: { isAgentAllow: true } }, 
                { path: '/DownloadCenter', component: DownloadCenter },
                { path: '/ExternalGame/:Classification', name: 'ExternalGame', component: ExternalGame },
                { path: '/AccountInfo', name: 'AccountInfo', component: AccountInfo },
                { path: '/AccountSecurity', name: 'AccountSecurity', component: AccountSecurity },
                { path: '/BankCard', name: 'BankCard', component: BankCard },
                { path: '/Deposit', name: 'Deposit', component: Deposit },
                { path: '/DrawHistory/:id', component: DrawHistory },
                { path: '/WinningNumbers/:id', component: WinningNumbers },
                { path: '/Announcement', name: 'Announcement', component: Announcement },
                { path: '/WithdrawRequest', name: 'WithdrawRequest', component: WithdrawRequest },
                { path: '/BetRecord', name: 'BetRecord', component: BetRecord },
                { path: '/ScheduleRecord', name: 'ScheduleRecord', component: ScheduleRecord },            
                { path: '/AwardDetail', name: 'AwardDetail', component: AwardDetail },
                { path: '/DepositAndWithdrawRecord', name: 'DepositAndWithdrawRecord', component: DepositAndWithdrawRecord },
                { path: '/ExternalGameTransRecord', name: 'ExternalGameTransRecord', component: ExternalGameTransRecord },
                { path: '/CashFlowRecord', name: 'CashFlowRecord', component: CashFlowRecord },
                { path: '/CustomerService', name: 'CustomerService', component: CustomerService },
                { path: '/ProfitReport', name: 'ProfitReport', component: ProfitReport },
                { path: '/TeamProfitReport', name: 'TeamProfitReport', component: TeamProfitReport, meta: { isAgentAllow: true } },
                { path: '/TeamExternalGameProfitReport', name: 'TeamExternalGameProfitReport', component: TeamExternalGameProfitReport, meta: { isAgentAllow: true } },                
                { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode },
                { path: '/Activity', name: 'Activity', component: Activity },
                { path: '/GraphicTeaching', name: 'GraphicTeaching', component: GraphicTeaching },
                { path: '/IFrame', name: 'IFrame', component: IFrame },
            ]
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == "Login") {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some(record => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some(record => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }

        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        }
        else if (to.name === "Home" && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/Login');
        }
        else {
            next('/Timeout');   // 認證已過期
        }
    }
});

// 投注一般、旗艦版導向
router.afterEach(to => {
    if (to.meta.betClientTemplate) {
        storage.local.set(storage.keys.BET_CLIENT_TEMPLATE, to.meta.betClientTemplate);
    }
});

function _betRedirect(to) {
    let clientTemplate = storage.local.get(storage.keys.BET_CLIENT_TEMPLATE) || 'Classic';
    clientTemplate = ['Classic', 'Pro'].includes(clientTemplate) ? clientTemplate : '';
    return { name: to.name + clientTemplate, params: to.params };
}

export default router;
